import React, { useEffect, useState } from "react";
import classes from "./WordGameHardMode.module.css";
import { useDispatch, useSelector } from "react-redux";
import {
    updateEightTile,
    updateEighteenTile,
    updateElevenTile,
    updateFifteenTile,
    updateFiveTile,
    updateFourTile,
    updateFourteenTile,
    updateNineTile,
    updateNineteenTile,
    updateOneTile,
    updateSevenTile,
    updateSeventeenTile,
    updateSixTile,
    updateSixteenTile,
    updateTenTile,
    updateThirteenTile,
    updateThirtyTile,
    updateThreeTile,
    updateTwelveTile,
    updateTwentyEightTile,
    updateTwentyFiveTile,
    updateTwentyFourTile,
    updateTwentyNineTile,
    updateTwentyOneTile,
    updateTwentySevenTile,
    updateTwentySixTile,
    updateTwentyThreeTile,
    updateTwentyTile,
    updateTwentyTwoTile,
    updateTwoTile,
} from "../../store/slices/wordGameSlice/tileWordSlice";
import { decreaseIndex, increaseIndex } from "../../store/slices/wordGameSlice/activeTileSlice";
import {
    setEnteredWord1,
    setEnteredWord2,
    setEnteredWord3,
    setEnteredWord4,
    setEnteredWord5,
    setEnteredWord6,
} from "../../store/slices/wordGameSlice/enteredWordSlice";
import {
    resetEnteredWord1,
    resetEnteredWord2,
    resetEnteredWord3,
    resetEnteredWord4,
    resetEnteredWord5,
    resetEnteredWord6,
    word1CheckHandler,
    word2CheckHandler,
    word3CheckHandler,
    word4CheckHandler,
    word5CheckHandler,
    word6CheckHandler,
} from "../../store/slices/wordGameSlice/wordResult";
import { setTargetWord } from "../../store/slices/wordGameSlice/targetWordSlice";
import CryptoJS from "crypto-js";
import GameOverModal from "./GameOverModal";
import WrongWordModal from "./WrongWordModal";
import WordGameLayout from "./WordGameLayout";
import Card from "./Card";
import CardHeader from "./CardHeader";
import Timer from "./Timer";
import {
    DecreaseTime,
    IncreaseTimeForProgress,
    SetProgress,
} from "../../store/slices/wordGameSlice/wordTimeSlice";
import WordGameInfoModal from "./WordGameInfoModal";
import { CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa6";
import { getProfile, saveUserPoints, saveWordGamePointsApi } from "../../http/http";
import { removeUserToken } from "../../store/slices/userTokenSlice";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { levels } from "../../utils/levels";
import Lottie from "lottie-react";
import GameOverAnimation from "../../animations/gameOver.json";

const decryptData = (encryptedData) => {
    const decryptedData = CryptoJS.AES.decrypt(
        encryptedData,
        "my little secret"
    ).toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedData);
};

const WordGameHardMode = () => {
    const [infoModal, setInfoModal] = useState(false);
    const [wrongWordModal, setWrongWordModal] = useState(false);
    const [gameOverLoading, setGameOverLoading] = useState(false);
    const { userToken } = useSelector(state => state.persisted.userTokenSlice);

    const { t } = useTranslation();

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const savePoints = async (points, result, word) => {
        try {
            setGameOverLoading(true);
            const response1 = await getProfile(userToken);
            // const response = await saveWordGamePointsApi(3, points, response1?.data?.result?.total_points, userToken);
            const response = await saveUserPoints(null, "Word Game", null, 3, points, response1?.data?.result?.total_points, userToken);

            setTimeout(() => {
                setGameOverLoading(false);
            }, 500);
            navigate("/word-game-over", {
                state: {
                    result,
                    word,
                    level: 3
                }
            })
        } catch (error) {

            if (error?.response?.status == 403) {
                dispatch(removeUserToken());
                toast.error(t("52"));
                navigate('/');
            }
            else {
                toast.error(error?.response?.data?.error?.error || error?.response?.error?.error || error?.response?.error || "Something Went Wrong!");
            }
        }
    }

    // 0 for lose and 1 for win

    useEffect(() => {
        setInfoModal(true);
    }, []);

    const closeModal = () => {
        setInfoModal(false);
    };

    const closeWrongWordModal = () => {
        setWrongWordModal(false);
    };

    const {
        oneTile,
        twoTile,
        threeTile,
        fourTile,
        fiveTile,
        sixTile,
        sevenTile,
        eightTile,
        nineTile,
        tenTile,
        elevenTile,
        twelveTile,
        thirteenTile,
        fourteenTile,
        fifteenTile,
        sixteenTile,
        seventeenTile,
        eighteenTile,
        nineteenTile,
        twentyTile,
        twentyOneTile,
        twentyTwoTile,
        twentyThreeTile,
        twentyFourTile,
        twentyFiveTile,
        twentySixTile,
        twentySevenTile,
        twentyEightTile,
        twentyNineTile,
        thirtyTile,
    } = useSelector((state) => state?.persisted?.tileWordSlice);

    const { index } = useSelector((state) => state?.persisted?.activeTileSlice);
    const { targetWord, shuffleTargetWord } = useSelector(
        (state) => state?.persisted?.targetWordSlice
    );

    const {
        enteredWord1,
        enteredWord2,
        enteredWord3,
        enteredWord4,
        enteredWord5,
        enteredWord6,
    } = useSelector((state) => state?.persisted?.enteredWordSlice);

    const {
        word1Check,
        word2Check,
        word3Check,
        word4Check,
        word5Check,
        word6Check,
        enteredWord1EnterPressed,
        enteredWord2EnterPressed,
        enteredWord3EnterPressed,
        enteredWord4EnterPressed,
        enteredWord5EnterPressed,
        enteredWord6EnterPressed,
        word1CheckDictionary,
        word2CheckDictionary,
        word3CheckDictionary,
        word4CheckDictionary,
        word5CheckDictionary,
        word6CheckDictionary,
    } = useSelector((state) => state?.persisted?.wordResultSlice);

    const checkWord = (data) => {
        dispatch(data.fnc({ word: data.word, targetedWord: data.targetWord }));
    };

    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            if (index == 6) {
                setTimeout(() => {
                    checkWord({
                        fnc: word1CheckHandler,
                        word: enteredWord1,
                        targetWord: targetWord,
                    });
                }, 500);
            }
            if (index == 11) {
                setTimeout(() => {
                    checkWord({
                        fnc: word2CheckHandler,
                        word: enteredWord2,
                        targetWord: targetWord,
                    });
                }, 500);
            }
            if (index == 16) {
                setTimeout(() => {
                    checkWord({
                        fnc: word3CheckHandler,
                        word: enteredWord3,
                        targetWord: targetWord,
                    });
                }, 500);
            }
            if (index == 21) {
                setTimeout(() => {
                    checkWord({
                        fnc: word4CheckHandler,
                        word: enteredWord4,
                        targetWord: targetWord,
                    });
                }, 500);
            }
            if (index == 26) {
                setTimeout(() => {
                    checkWord({
                        fnc: word5CheckHandler,
                        word: enteredWord5,
                        targetWord: targetWord,
                    });
                }, 500);
            }
            if (index == 31) {
                setTimeout(() => {
                    checkWord({
                        fnc: word6CheckHandler,
                        word: enteredWord6,
                        targetWord: targetWord,
                    });
                }, 500);
            }
        }

        if (event.key === "Backspace" || event.key === "Delete") {
            deleteKey();
            return;
        }

        if (event.key.match(/^[a-z]$/)) {
            pressKey(event.key);
        }
    };

    useEffect(() => {
        document.addEventListener("keydown", handleKeyDown);

        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [handleKeyDown]);

    useEffect(() => {
        dispatch(setTargetWord());
    }, []);

    useEffect(() => {
        if (
            word1Check == true ||
            word2Check == true ||
            word3Check == true ||
            word4Check == true ||
            word5Check == true ||
            word6Check == true
        ) {
            let word = decryptData(targetWord);
            savePoints(levels?.[2]?.points, "win", word);
        }
        if (
            word1CheckDictionary == false ||
            word2CheckDictionary == false ||
            word3CheckDictionary == false ||
            word4CheckDictionary == false ||
            word5CheckDictionary == false ||
            word6CheckDictionary == false
        ) {
            if (word1CheckDictionary == false) {
                dispatch(resetEnteredWord1());
            }
            if (word2CheckDictionary == false) {
                dispatch(resetEnteredWord2());
            }
            if (word3CheckDictionary == false) {
                dispatch(resetEnteredWord3());
            }
            if (word4CheckDictionary == false) {
                dispatch(resetEnteredWord4());
            }
            if (word5CheckDictionary == false) {
                dispatch(resetEnteredWord5());
            }
            if (word6CheckDictionary == false) {
                dispatch(resetEnteredWord6());
            }
            setWrongWordModal(true);
        }
    }, [
        word1Check,
        word2Check,
        word3Check,
        word4Check,
        word5Check,
        word6Check,
        word1CheckDictionary,
        word2CheckDictionary,
        word3CheckDictionary,
        word4CheckDictionary,
        word5CheckDictionary,
        word6CheckDictionary,
    ]);

    useEffect(() => {
        if (enteredWord6EnterPressed && word6CheckDictionary) {
            let word = decryptData(targetWord);
            savePoints(0, "lose", word);
        }
    }, [enteredWord6EnterPressed, word6CheckDictionary]);

    const pressKey = (key) => {
        if (enteredWord1.length == 5 && !enteredWord1EnterPressed) {
            return;
        }

        if (enteredWord2.length == 5 && !enteredWord2EnterPressed) {
            return;
        }

        if (enteredWord3.length == 5 && !enteredWord3EnterPressed) {
            return;
        }

        if (enteredWord4.length == 5 && !enteredWord4EnterPressed) {
            return;
        }

        if (enteredWord5.length == 5 && !enteredWord5EnterPressed) {
            return;
        }
        if (enteredWord6.length == 5 && !enteredWord6EnterPressed) {
            return;
        }
        if (index == 1) {
            dispatch(updateOneTile(String(key).toUpperCase()));
            dispatch(setEnteredWord1([String(key).toUpperCase()]));
            dispatch(increaseIndex());
        }
        if (index == 2) {
            dispatch(updateTwoTile(String(key).toUpperCase()));
            dispatch(setEnteredWord1([oneTile, String(key).toUpperCase()]));
            dispatch(increaseIndex());
        }
        if (index == 3) {
            dispatch(updateThreeTile(String(key).toUpperCase()));
            dispatch(setEnteredWord1([oneTile, twoTile, String(key).toUpperCase()]));
            dispatch(increaseIndex());
        }
        if (index == 4) {
            dispatch(updateFourTile(String(key).toUpperCase()));
            dispatch(
                setEnteredWord1([
                    oneTile,
                    twoTile,
                    threeTile,
                    String(key).toUpperCase(),
                ])
            );
            dispatch(increaseIndex());
        }
        if (index == 5) {
            dispatch(updateFiveTile(String(key).toUpperCase()));
            dispatch(
                setEnteredWord1([
                    oneTile,
                    twoTile,
                    threeTile,
                    fourTile,
                    String(key).toUpperCase(),
                ])
            );
            dispatch(increaseIndex());
        }
        if (index == 6) {
            dispatch(updateSixTile(String(key).toUpperCase()));
            dispatch(setEnteredWord2([String(key).toUpperCase()]));
            dispatch(increaseIndex());
        }
        if (index == 7) {
            dispatch(updateSevenTile(String(key).toUpperCase()));
            dispatch(setEnteredWord2([sixTile, String(key).toUpperCase()]));
            dispatch(increaseIndex());
        }
        if (index == 8) {
            dispatch(updateEightTile(String(key).toUpperCase()));
            dispatch(
                setEnteredWord2([sixTile, sevenTile, String(key).toUpperCase()])
            );
            dispatch(increaseIndex());
        }
        if (index == 9) {
            dispatch(updateNineTile(String(key).toUpperCase()));
            dispatch(
                setEnteredWord2([
                    sixTile,
                    sevenTile,
                    eightTile,
                    String(key).toUpperCase(),
                ])
            );
            dispatch(increaseIndex());
        }
        if (index == 10) {
            dispatch(updateTenTile(String(key).toUpperCase()));
            dispatch(
                setEnteredWord2([
                    sixTile,
                    sevenTile,
                    eightTile,
                    nineTile,
                    String(key).toUpperCase(),
                ])
            );
            dispatch(increaseIndex());
        }
        if (index == 11) {
            dispatch(updateElevenTile(String(key).toUpperCase()));
            dispatch(setEnteredWord3([String(key).toUpperCase()]));
            dispatch(increaseIndex());
        }
        if (index == 12) {
            dispatch(updateTwelveTile(String(key).toUpperCase()));
            dispatch(setEnteredWord3([elevenTile, String(key).toUpperCase()]));
            dispatch(increaseIndex());
        }
        if (index == 13) {
            dispatch(updateThirteenTile(String(key).toUpperCase()));
            dispatch(
                setEnteredWord3([elevenTile, twelveTile, String(key).toUpperCase()])
            );
            dispatch(increaseIndex());
        }
        if (index == 14) {
            dispatch(updateFourteenTile(String(key).toUpperCase()));
            dispatch(
                setEnteredWord3([
                    elevenTile,
                    twelveTile,
                    thirteenTile,
                    String(key).toUpperCase(),
                ])
            );
            dispatch(increaseIndex());
        }
        if (index == 15) {
            dispatch(updateFifteenTile(String(key).toUpperCase()));
            dispatch(
                setEnteredWord3([
                    elevenTile,
                    twelveTile,
                    thirteenTile,
                    fourteenTile,
                    String(key).toUpperCase(),
                ])
            );
            dispatch(increaseIndex());
        }
        if (index == 16) {
            dispatch(updateSixteenTile(String(key).toUpperCase()));
            dispatch(setEnteredWord4([String(key).toUpperCase()]));
            dispatch(increaseIndex());
        }
        if (index == 17) {
            dispatch(updateSeventeenTile(String(key).toUpperCase()));
            dispatch(setEnteredWord4([sixteenTile, String(key).toUpperCase()]));
            dispatch(increaseIndex());
        }
        if (index == 18) {
            dispatch(updateEighteenTile(String(key).toUpperCase()));
            dispatch(
                setEnteredWord4([sixteenTile, seventeenTile, String(key).toUpperCase()])
            );
            dispatch(increaseIndex());
        }
        if (index == 19) {
            dispatch(updateNineteenTile(String(key).toUpperCase()));
            dispatch(
                setEnteredWord4([
                    sixteenTile,
                    seventeenTile,
                    eighteenTile,
                    String(key).toUpperCase(),
                ])
            );
            dispatch(increaseIndex());
        }
        if (index == 20) {
            dispatch(updateTwentyTile(String(key).toUpperCase()));
            dispatch(
                setEnteredWord4([
                    sixteenTile,
                    seventeenTile,
                    eighteenTile,
                    nineteenTile,
                    String(key).toUpperCase(),
                ])
            );
            dispatch(increaseIndex());
        }
        if (index == 21) {
            dispatch(updateTwentyOneTile(String(key).toUpperCase()));
            dispatch(setEnteredWord5([String(key).toUpperCase()]));
            dispatch(increaseIndex());
        }
        if (index == 22) {
            dispatch(updateTwentyTwoTile(String(key).toUpperCase()));
            dispatch(setEnteredWord5([twentyOneTile, String(key).toUpperCase()]));
            dispatch(increaseIndex());
        }
        if (index == 23) {
            dispatch(updateTwentyThreeTile(String(key).toUpperCase()));
            dispatch(
                setEnteredWord5([
                    twentyOneTile,
                    twentyTwoTile,
                    String(key).toUpperCase(),
                ])
            );
            dispatch(increaseIndex());
        }
        if (index == 24) {
            dispatch(updateTwentyFourTile(String(key).toUpperCase()));
            dispatch(
                setEnteredWord5([
                    twentyOneTile,
                    twentyTwoTile,
                    twentyThreeTile,
                    String(key).toUpperCase(),
                ])
            );
            dispatch(increaseIndex());
        }
        if (index == 25) {
            dispatch(updateTwentyFiveTile(String(key).toUpperCase()));
            dispatch(
                setEnteredWord5([
                    twentyOneTile,
                    twentyTwoTile,
                    twentyThreeTile,
                    twentyFourTile,
                    String(key).toUpperCase(),
                ])
            );
            dispatch(increaseIndex());
        }
        if (index == 26) {
            dispatch(updateTwentySixTile(String(key).toUpperCase()));
            dispatch(setEnteredWord6([String(key).toUpperCase()]));
            dispatch(increaseIndex());
        }
        if (index == 27) {
            dispatch(updateTwentySevenTile(String(key).toUpperCase()));
            dispatch(setEnteredWord6([twentySixTile, String(key).toUpperCase()]));
            dispatch(increaseIndex());
        }
        if (index == 28) {
            dispatch(updateTwentyEightTile(String(key).toUpperCase()));
            dispatch(
                setEnteredWord6([
                    twentySixTile,
                    twentySevenTile,
                    String(key).toUpperCase(),
                ])
            );
            dispatch(increaseIndex());
        }
        if (index == 29) {
            dispatch(updateTwentyNineTile(String(key).toUpperCase()));
            dispatch(
                setEnteredWord6([
                    twentySixTile,
                    twentySevenTile,
                    twentyEightTile,
                    String(key).toUpperCase(),
                ])
            );
            dispatch(increaseIndex());
        }
        if (index == 30) {
            dispatch(updateThirtyTile(String(key).toUpperCase()));
            dispatch(
                setEnteredWord6([
                    twentySixTile,
                    twentySevenTile,
                    twentyEightTile,
                    twentyNineTile,
                    String(key).toUpperCase(),
                ])
            );
            dispatch(increaseIndex());
        }
    };

    const deleteKey = () => {
        if (index == 31 && enteredWord6EnterPressed) {
            return;
        }
        if (index == 26 && enteredWord5EnterPressed) {
            return;
        }
        if (index == 21 && enteredWord4EnterPressed) {
            return;
        }
        if (index == 16 && enteredWord3EnterPressed) {
            return;
        }
        if (index == 11 && enteredWord2EnterPressed) {
            return;
        }
        if (index == 6 && enteredWord1EnterPressed) {
            return;
        }
        if (index == 2) {
            dispatch(updateOneTile(""));
            dispatch(setEnteredWord1([""]));
            dispatch(decreaseIndex());
        }
        if (index == 3) {
            dispatch(updateTwoTile(""));
            dispatch(setEnteredWord1([""]));
            dispatch(decreaseIndex());
        }
        if (index == 4) {
            dispatch(updateThreeTile(""));
            dispatch(setEnteredWord1([""]));
            dispatch(decreaseIndex());
        }
        if (index == 5) {
            dispatch(updateFourTile(""));
            dispatch(setEnteredWord1([""]));
            dispatch(decreaseIndex());
        }
        if (index == 6) {
            dispatch(updateFiveTile(""));
            dispatch(setEnteredWord1([""]));
            dispatch(decreaseIndex());
        }
        if (index == 7) {
            dispatch(updateSixTile(""));
            dispatch(setEnteredWord2([""]));
            dispatch(decreaseIndex());
        }
        if (index == 8) {
            dispatch(updateSevenTile(""));
            dispatch(setEnteredWord2([""]));
            dispatch(decreaseIndex());
        }
        if (index == 9) {
            dispatch(updateEightTile(""));
            dispatch(setEnteredWord2([""]));
            dispatch(decreaseIndex());
        }
        if (index == 10) {
            dispatch(updateNineTile(""));
            dispatch(setEnteredWord2([""]));
            dispatch(decreaseIndex());
        }
        if (index == 11) {
            dispatch(updateTenTile(""));
            dispatch(setEnteredWord2([""]));
            dispatch(decreaseIndex());
        }
        if (index == 12) {
            dispatch(updateElevenTile(""));
            dispatch(setEnteredWord3([""]));
            dispatch(decreaseIndex());
        }
        if (index == 13) {
            dispatch(updateTwelveTile(""));
            dispatch(setEnteredWord3([""]));
            dispatch(decreaseIndex());
        }
        if (index == 14) {
            dispatch(updateThirteenTile(""));
            dispatch(setEnteredWord3([""]));
            dispatch(decreaseIndex());
        }
        if (index == 15) {
            dispatch(updateFourteenTile(""));
            dispatch(setEnteredWord3([""]));
            dispatch(decreaseIndex());
        }
        if (index == 16) {
            dispatch(updateFifteenTile(""));
            dispatch(setEnteredWord3([""]));
            dispatch(decreaseIndex());
        }
        if (index == 17) {
            dispatch(updateSixteenTile(""));
            dispatch(setEnteredWord4([""]));
            dispatch(decreaseIndex());
        }
        if (index == 18) {
            dispatch(updateSeventeenTile(""));
            dispatch(setEnteredWord4([""]));
            dispatch(decreaseIndex());
        }
        if (index == 19) {
            dispatch(updateEighteenTile(""));
            dispatch(setEnteredWord4([""]));
            dispatch(decreaseIndex());
        }
        if (index == 20) {
            dispatch(updateNineteenTile(""));
            dispatch(setEnteredWord4([""]));
            dispatch(decreaseIndex());
        }
        if (index == 21) {
            dispatch(updateTwentyTile(""));
            dispatch(setEnteredWord4([""]));
            dispatch(decreaseIndex());
        }
        if (index == 22) {
            dispatch(updateTwentyOneTile(""));
            dispatch(setEnteredWord5([""]));
            dispatch(decreaseIndex());
        }
        if (index == 23) {
            dispatch(updateTwentyTwoTile(""));
            dispatch(setEnteredWord5([""]));
            dispatch(decreaseIndex());
        }
        if (index == 24) {
            dispatch(updateTwentyThreeTile(""));
            dispatch(setEnteredWord5([""]));
            dispatch(decreaseIndex());
        }
        if (index == 25) {
            dispatch(updateTwentyFourTile(""));
            dispatch(setEnteredWord5([""]));
            dispatch(decreaseIndex());
        }
        if (index == 26) {
            dispatch(updateTwentyFiveTile(""));
            dispatch(setEnteredWord5([""]));
            dispatch(decreaseIndex());
        }
        if (index == 27) {
            dispatch(updateTwentySixTile(""));
            dispatch(setEnteredWord6([""]));
            dispatch(decreaseIndex());
        }
        if (index == 28) {
            dispatch(updateTwentySevenTile());
            dispatch(setEnteredWord6([""]));
            dispatch(decreaseIndex());
        }
        if (index == 29) {
            dispatch(updateTwentyEightTile(""));
            dispatch(setEnteredWord6([""]));
            dispatch(decreaseIndex());
        }
        if (index == 30) {
            dispatch(updateTwentyNineTile(""));
            dispatch(setEnteredWord6([""]));
            dispatch(decreaseIndex());
        }
        if (index == 31) {
            dispatch(updateThirtyTile(""));
            dispatch(setEnteredWord6([""]));
            dispatch(decreaseIndex());
        }
    };

    const { time, progress } = useSelector((state) => state?.persisted?.wordTimeSlice);

    useEffect(() => {
        if (time > 0 && !infoModal) {
            const timeoutId = setTimeout(() => {
                dispatch(DecreaseTime());
                dispatch(IncreaseTimeForProgress());
                dispatch(SetProgress());
            }, 1000);

            return () => clearTimeout(timeoutId);
        } else if (time <= 0) {
            // show popup
            let word = decryptData(targetWord);
            savePoints(0, "lose", word);
        }
    }, [time, dispatch, infoModal]);

    return (
        <>
            <WordGameLayout>
                {/* <Timer progress={progress} /> */}
                <Card>
                    {gameOverLoading ? (<>
                        <div className={classes.game_over_animation_container}>
                            <Lottie animationData={GameOverAnimation} loop autoPlay className={classes.gameOverAnimation} />
                        </div>
                    </>) : (
                        <>
                            <div className={classes.layout}>
                                <div className={classes.back_button} onClick={() => {
                                    navigate("/home");
                                }}>
                                    <FaArrowLeft className={classes.back_icon} />
                                </div>
                                <div className={classes.clock_container}>
                                    <div className={classes.circular_clock_container}>
                                        <CircularProgress variant="determinate" color="primary" value={progress} />
                                        <p className={classes.clock_time} style={{ color: time <= 10 && "red" }}>
                                            {time}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <CardHeader title={t("142")} />

                            <div className={classes.tiles_grid}>
                                <div
                                    className={`${classes.tile} ${word1Check?.length > 0 &&
                                        word1Check.find((item) => item.index === 0) &&
                                        classes.tile_character_right
                                        } ${enteredWord1EnterPressed && classes.flip_tile}`}
                                >
                                    {oneTile}
                                </div>
                                <div
                                    className={`${classes.tile} ${word1Check?.length > 0 &&
                                        word1Check.find((item) => item.index === 1) &&
                                        classes.tile_character_right
                                        } ${enteredWord1EnterPressed && classes.flip_tile}`}
                                >
                                    {twoTile}
                                </div>
                                <div
                                    className={`${classes.tile} ${word1Check?.length > 0 &&
                                        word1Check.find((item) => item.index === 2) &&
                                        classes.tile_character_right
                                        } ${enteredWord1EnterPressed && classes.flip_tile}`}
                                >
                                    {threeTile}
                                </div>
                                <div
                                    className={`${classes.tile} ${word1Check?.length > 0 &&
                                        word1Check.find((item) => item.index === 3) &&
                                        classes.tile_character_right
                                        } ${enteredWord1EnterPressed && classes.flip_tile}`}
                                >
                                    {fourTile}
                                </div>
                                <div
                                    className={`${classes.tile} ${word1Check?.length > 0 &&
                                        word1Check.find((item) => item.index === 4) &&
                                        classes.tile_character_right
                                        } ${enteredWord1EnterPressed && classes.flip_tile}`}
                                >
                                    {fiveTile}
                                </div>
                                <div
                                    className={`${classes.tile} ${word2Check?.length > 0 &&
                                        word2Check.find((item) => item.index === 0) &&
                                        classes.tile_character_right
                                        } ${enteredWord2EnterPressed && classes.flip_tile}`}
                                >
                                    {sixTile}
                                </div>
                                <div
                                    className={`${classes.tile} ${word2Check?.length > 0 &&
                                        word2Check.find((item) => item.index === 1) &&
                                        classes.tile_character_right
                                        } ${enteredWord2EnterPressed && classes.flip_tile}`}
                                >
                                    {sevenTile}
                                </div>
                                <div
                                    className={`${classes.tile} ${word2Check?.length > 0 &&
                                        word2Check.find((item) => item.index === 2) &&
                                        classes.tile_character_right
                                        } ${enteredWord2EnterPressed && classes.flip_tile}`}
                                >
                                    {eightTile}
                                </div>
                                <div
                                    className={`${classes.tile} ${word2Check?.length > 0 &&
                                        word2Check.find((item) => item.index === 3) &&
                                        classes.tile_character_right
                                        } ${enteredWord2EnterPressed && classes.flip_tile}`}
                                >
                                    {nineTile}
                                </div>
                                <div
                                    className={`${classes.tile} ${word2Check?.length > 0 &&
                                        word2Check.find((item) => item.index === 4) &&
                                        classes.tile_character_right
                                        } ${enteredWord2EnterPressed && classes.flip_tile}`}
                                >
                                    {tenTile}
                                </div>
                                <div
                                    className={`${classes.tile} ${word3Check?.length > 0 &&
                                        word3Check.find((item) => item.index === 0) &&
                                        classes.tile_character_right
                                        } ${enteredWord3EnterPressed && classes.flip_tile}`}
                                >
                                    {elevenTile}
                                </div>
                                <div
                                    className={`${classes.tile} ${word3Check?.length > 0 &&
                                        word3Check.find((item) => item.index === 1) &&
                                        classes.tile_character_right
                                        } ${enteredWord3EnterPressed && classes.flip_tile}`}
                                >
                                    {twelveTile}
                                </div>
                                <div
                                    className={`${classes.tile} ${word3Check?.length > 0 &&
                                        word3Check.find((item) => item.index === 2) &&
                                        classes.tile_character_right
                                        } ${enteredWord3EnterPressed && classes.flip_tile}`}
                                >
                                    {thirteenTile}
                                </div>
                                <div
                                    className={`${classes.tile} ${word3Check?.length > 0 &&
                                        word3Check.find((item) => item.index === 3) &&
                                        classes.tile_character_right
                                        } ${enteredWord3EnterPressed && classes.flip_tile}`}
                                >
                                    {fourteenTile}
                                </div>
                                <div
                                    className={`${classes.tile} ${word3Check?.length > 0 &&
                                        word3Check.find((item) => item.index === 4) &&
                                        classes.tile_character_right
                                        } ${enteredWord3EnterPressed && classes.flip_tile}`}
                                >
                                    {fifteenTile}
                                </div>
                                <div
                                    className={`${classes.tile} ${word4Check?.length > 0 &&
                                        word4Check.find((item) => item.index === 0) &&
                                        classes.tile_character_right
                                        } ${enteredWord4EnterPressed && classes.flip_tile}`}
                                >
                                    {sixteenTile}
                                </div>
                                <div
                                    className={`${classes.tile} ${word4Check?.length > 0 &&
                                        word4Check.find((item) => item.index === 1) &&
                                        classes.tile_character_right
                                        } ${enteredWord4EnterPressed && classes.flip_tile}`}
                                >
                                    {seventeenTile}
                                </div>
                                <div
                                    className={`${classes.tile} ${word4Check?.length > 0 &&
                                        word4Check.find((item) => item.index === 2) &&
                                        classes.tile_character_right
                                        } ${enteredWord4EnterPressed && classes.flip_tile}`}
                                >
                                    {eighteenTile}
                                </div>
                                <div
                                    className={`${classes.tile} ${word4Check?.length > 0 &&
                                        word4Check.find((item) => item.index === 3) &&
                                        classes.tile_character_right
                                        } ${enteredWord4EnterPressed && classes.flip_tile}`}
                                >
                                    {nineteenTile}
                                </div>
                                <div
                                    className={`${classes.tile} ${word4Check?.length > 0 &&
                                        word4Check.find((item) => item.index === 4) &&
                                        classes.tile_character_right
                                        } ${enteredWord4EnterPressed && classes.flip_tile}`}
                                >
                                    {twentyTile}
                                </div>
                                <div
                                    className={`${classes.tile} ${word5Check?.length > 0 &&
                                        word5Check.find((item) => item.index === 0) &&
                                        classes.tile_character_right
                                        }  ${enteredWord5EnterPressed && classes.flip_tile}`}
                                >
                                    {twentyOneTile}
                                </div>
                                <div
                                    className={`${classes.tile} ${word5Check?.length > 0 &&
                                        word5Check.find((item) => item.index === 1) &&
                                        classes.tile_character_right
                                        } ${enteredWord5EnterPressed && classes.flip_tile}`}
                                >
                                    {twentyTwoTile}
                                </div>
                                <div
                                    className={`${classes.tile} ${word5Check?.length > 0 &&
                                        word5Check.find((item) => item.index === 2) &&
                                        classes.tile_character_right
                                        } ${enteredWord5EnterPressed && classes.flip_tile}`}
                                >
                                    {twentyThreeTile}
                                </div>
                                <div
                                    className={`${classes.tile} ${word5Check?.length > 0 &&
                                        word5Check.find((item) => item.index === 3) &&
                                        classes.tile_character_right
                                        } ${enteredWord5EnterPressed && classes.flip_tile}`}
                                >
                                    {twentyFourTile}
                                </div>
                                <div
                                    className={`${classes.tile} ${word5Check?.length > 0 &&
                                        word5Check.find((item) => item.index === 4) &&
                                        classes.tile_character_right
                                        } ${enteredWord5EnterPressed && classes.flip_tile}`}
                                >
                                    {twentyFiveTile}
                                </div>
                                <div
                                    className={`${classes.tile} ${word6Check?.length > 0 &&
                                        word6Check.find((item) => item.index === 0) &&
                                        classes.tile_character_right
                                        } ${enteredWord6EnterPressed && classes.flip_tile}`}
                                >
                                    {twentySixTile}
                                </div>
                                <div
                                    className={`${classes.tile} ${word6Check?.length > 0 &&
                                        word6Check.find((item) => item.index === 1) &&
                                        classes.tile_character_right
                                        } ${enteredWord6EnterPressed && classes.flip_tile}`}
                                >
                                    {twentySevenTile}
                                </div>
                                <div
                                    className={`${classes.tile} ${word6Check?.length > 0 &&
                                        word6Check.find((item) => item.index === 2) &&
                                        classes.tile_character_right
                                        } ${enteredWord6EnterPressed && classes.flip_tile}`}
                                >
                                    {twentyEightTile}
                                </div>
                                <div
                                    className={`${classes.tile} ${word6Check?.length > 0 &&
                                        word6Check.find((item) => item.index === 3) &&
                                        classes.tile_character_right
                                        } ${enteredWord6EnterPressed && classes.flip_tile}`}
                                >
                                    {twentyNineTile}
                                </div>
                                <div
                                    className={`${classes.tile} ${word6Check?.length > 0 &&
                                        word6Check.find((item) => item.index === 4) &&
                                        classes.tile_character_right
                                        } ${enteredWord6EnterPressed && classes.flip_tile}`}
                                >
                                    {thirtyTile}
                                </div>
                            </div>
                        </>
                    )}

                </Card>
                <div className={classes.keyboard_container}>
                    <div className={classes.keypad_1}>
                        <div className={classes.key} onClick={() => pressKey("Q")}>
                            Q
                        </div>
                        <div className={classes.key} onClick={() => pressKey("W")}>
                            W
                        </div>
                        <div className={classes.key} onClick={() => pressKey("E")}>
                            E
                        </div>
                        <div className={classes.key} onClick={() => pressKey("R")}>
                            R
                        </div>
                        <div className={classes.key} onClick={() => pressKey("T")}>
                            T
                        </div>
                        <div className={classes.key} onClick={() => pressKey("Y")}>
                            Y
                        </div>
                        <div className={classes.key} onClick={() => pressKey("U")}>
                            U
                        </div>
                        <div className={classes.key} onClick={() => pressKey("I")}>
                            I
                        </div>
                        <div className={classes.key} onClick={() => pressKey("O")}>
                            O
                        </div>
                        <div className={classes.key} onClick={() => pressKey("P")}>
                            P
                        </div>
                    </div>
                    <div className={classes.keypad_2}>
                        <div className={classes.key} onClick={() => pressKey("A")}>
                            A
                        </div>
                        <div className={classes.key} onClick={() => pressKey("S")}>
                            S
                        </div>
                        <div className={classes.key} onClick={() => pressKey("D")}>
                            D
                        </div>
                        <div className={classes.key} onClick={() => pressKey("F")}>
                            F
                        </div>
                        <div className={classes.key} onClick={() => pressKey("G")}>
                            G
                        </div>
                        <div className={classes.key} onClick={() => pressKey("H")}>
                            H
                        </div>
                        <div className={classes.key} onClick={() => pressKey("J")}>
                            J
                        </div>
                        <div className={classes.key} onClick={() => pressKey("K")}>
                            K
                        </div>
                        <div className={classes.key} onClick={() => pressKey("L")}>
                            L
                        </div>
                    </div>
                    <div className={classes.keypad_3}>
                        <div
                            className={classes.key_large}
                            onClick={() => handleKeyDown({ key: "Enter" })}
                        >
                            ENTER
                        </div>
                        <div className={classes.key} onClick={() => pressKey("Z")}>
                            Z
                        </div>
                        <div className={classes.key} onClick={() => pressKey("X")}>
                            X
                        </div>
                        <div className={classes.key} onClick={() => pressKey("C")}>
                            C
                        </div>
                        <div className={classes.key} onClick={() => pressKey("V")}>
                            V
                        </div>
                        <div className={classes.key} onClick={() => pressKey("B")}>
                            B
                        </div>
                        <div className={classes.key} onClick={() => pressKey("N")}>
                            N
                        </div>
                        <div className={classes.key} onClick={() => pressKey("M")}>
                            M
                        </div>
                        <div className={classes.key_large} onClick={deleteKey}>
                            Backspace
                        </div>
                    </div>
                </div>
            </WordGameLayout>
            {infoModal && <WordGameInfoModal closeModal={closeModal} />}
            {wrongWordModal && (
                <WrongWordModal closeWrongWordModal={closeWrongWordModal} />
            )}
        </>
    );
};

export default WordGameHardMode;
